// extracted by extract-css-chunks-webpack-plugin
module.exports = {"stars":"OrderRatingModal-46bd5df5baa20f0c"};